import { render, staticRenderFns } from "./storeAccount.vue?vue&type=template&id=2165f852&scoped=true&"
import script from "./storeAccount.vue?vue&type=script&lang=js&"
export * from "./storeAccount.vue?vue&type=script&lang=js&"
import style0 from "./storeAccount.vue?vue&type=style&index=0&id=2165f852&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2165f852",
  null
  
)

export default component.exports